import axios from "axios";
import type { GetServerSideProps, InferGetServerSidePropsType } from "next";

import { BreadCrumb } from "@/components/BreadCrumb";
import type { GetCategoryDto } from "@/entities/types/entities";
import { PageLayout } from "@/layouts/PageLayout";
import Build from "@/shared/assests/tc_background.webp";
import { Routes } from "@/shared/constants";
import { API_BASE } from "@/shared/constants/private";
import { BuildingPage } from "@/view/Building/Building";

export default function Building({ sectionId, sectionNumber, cat }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const items = [{ label: "Реклама в торговых центрах" }];

    return (
        <PageLayout
            title="Реклама в ТЦ Санкт-Петербурга | Indoor-экраны и баннеры"
            description="Эффективная реклама в торговых центрах: лайтбоксы, ролл апы, видеомониторы. Высокий трафик, привлечение покупателей. Запуск от 1 дня!"
            page_type="service"
        >
            <BreadCrumb model={items} />
            <BuildingPage
                listCategory={cat}
                sectionId={sectionId}
                sectionNumber={sectionNumber}
                alt="TC"
                src={Build}
                url={Routes.POSTERTC}
                title="Реклама в торговых центрах"
                description="Торговые центры — это места, где люди не только покупают, но и отдыхают. В макетах для рекламы в торговых центрах используйте яркие цвета и креативный подход. Кто не остановится на мгновение, увидев что-то действительно интересное?!"
            />
        </PageLayout>
    );
}
export const getServerSideProps: GetServerSideProps = async () => {
    const sectionId = "025a5106-c26f-4649-932c-5d076cbddd2e";
    const sectionNumber = 3;

    const resCat = await axios<GetCategoryDto[]>(`${API_BASE}/category`, {
        params: { sectionId: sectionId, onlyPublished: true } }).catch(() => ({ data: [] }))

    return {
        props: {
            sectionId: sectionId,
            sectionNumber: sectionNumber,
            cat: resCat.data,
        },
    };
};
